module.exports = __webpack_public_path__ + "img/jlogoq.948c3799.png";